import AgingTable from '../reports/AgingTable.vue';
import OrderTable from '../reports/OrderTable.vue';
import InventoryTable from '../reports/InventoryTable.vue';
import SnapshotTable from '../reports/SnapshotTable.vue';
import VendorAllocatedTable from '../vendors/VendorAllocatedTable.vue';

if (document.getElementById('reports-table')) {
  const table = document.getElementById('reports-table');

  var app = new Vue({
    el: '#reports-table',
    template: '<OrderTable :orders="this.orders"/>',
    data() {
      return {
        orders: JSON.parse(table.dataset.orders)
      };
    },
    created() {
      window.vue = this;
    },
    components: {
      OrderTable
    },
  });
}

if (document.getElementById('inventory-table')) {
  const table = document.getElementById('inventory-table');

  var app = new Vue({
    el: '#inventory-table',
    template: '<InventoryTable :orders="this.orders" />',
    data() {
      return {
        orders: JSON.parse(table.dataset.orders)
      };
    },
    created() {
      window.vue = this;
    },
    components: {
      InventoryTable
    },
  });
}

if (document.getElementById('vendor-allocated-table')) {
  const table = document.getElementById('vendor-allocated-table');

  var app = new Vue({
    el: '#vendor-allocated-table',
    template: '<VendorAllocatedTable :orders="this.orders" :path="this.path" :products="this.products" />',
    data() {
      return {
        orders: JSON.parse(table.dataset.orders),
        path: table.dataset.path,
        products: JSON.parse(table.dataset.products)
      };
    },
    created() {
      window.vue = this;
    },
    components: {
      VendorAllocatedTable
    },
  });
}

if (document.getElementById('aging-table')) {
  const table = document.getElementById('aging-table');

  var app = new Vue({
    el: '#aging-table',
    template: '<AgingTable :orders="this.orders"/>',
    data() {
      return {
        orders: JSON.parse(table.dataset.orders)
      };
    },
    created() {
      window.vue = this;
    },
    components: {
      AgingTable
    },
  });
}

if (document.getElementById('snapshot-table')) {
  const table = document.getElementById('snapshot-table');

  var app = new Vue({
    el: '#snapshot-table',
    template: '<SnapshotTable :orders="this.orders" :path="this.path" :products="this.products" />',
    data() {
      return {
        orders: JSON.parse(table.dataset.orders),
        path: table.dataset.path,
        products: JSON.parse(table.dataset.products)
      };
    },
    created() {
      window.vue = this;
    },
    components: {
      SnapshotTable
    },
  });
}